import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { captureAttributionFromCurrentUrl } from "../../../utils/campaignAttribution";

/**
 * Records attribution touchpoints on route changes (app-wide).
 */
export default function CampaignAttributionTracker() {
  const location = useLocation();

  useEffect(() => {
    captureAttributionFromCurrentUrl({
      pagePath: location.pathname,
      eventName: "page_view",
    });
  }, [location.pathname, location.search]);

  return null;
}
